import { render, staticRenderFns } from "./LiveLivingOption.vue?vue&type=template&id=ff5d64e8&"
import script from "./LiveLivingOption.vue?vue&type=script&lang=js&"
export * from "./LiveLivingOption.vue?vue&type=script&lang=js&"
import style0 from "./LiveLivingOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports